<ng-container *ngIf="contextMenuItems.length > 0 && seEstaMostrando">
    <ul [ngStyle]="ngStyle">
        <li *ngFor="let menuItem of contextMenuItems; index as i"
                (click)="onContextMenuClick(menuItem, $event)">
            {{ menuItem.label }}
        </li>
    </ul>
</ng-container>